import React, { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  SaveButton,
  EditButton,
  Toolbar,
  useNotify,
  useRecordContext,
  useResourceContext,
  useResourceDefinitions,
  useStore,
  useTranslate,
  useRedirect
} from 'react-admin'
import { Edit, Save } from '@mui/icons-material'
import { Button } from '@mui/material'
import { getResourceName } from 'src/helper/getResourceName'
import { DeleteButtonWithConfirmation } from '../buttons/DeleteButtonWithConfirmation'
import { LoadingButton } from '@mui/lab'
import get from 'lodash/get'

export const CardCrudBottomButtons = ({
  btnEdit,
  btnSave,
  btnDelete,
  btnCancel,
  btnPreview,
  fieldsName = [],
  genderElement,
  beforeSubmit,
  loading = false,
  loadingPreview = false,
  handlePreview,
  previewIgnoreFields = []
}) => {
  const redirect = useRedirect()
  const translate = useTranslate()
  const notify = useNotify()
  const record = useRecordContext()
  const resource = useResourceContext()
  const formContext = useFormContext()
  const propsResource = useResourceDefinitions()
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resource]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resource])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  const handleClick = (e) => {
    if (beforeSubmit && !beforeSubmit()) {
      e.preventDefault()
    }
  }

  const handleCancel = () => {
    redirect('list', resource)
  }

  const onPreviewClick = async () => {
    if (!formContext) return

    await formContext.trigger()
    if (previewIgnoreFields.length) {
      formContext.clearErrors(previewIgnoreFields)
    }
    const errors = get(formContext.formState, 'errors') || {}
    const errorFields = Object.keys(errors)
    const blockingErrors = errorFields.filter((field) => !previewIgnoreFields.includes(field))

    if (blockingErrors.length) {
      notify(translate('ra.message.complete_required_fields'), { type: 'warning' })
      return
    }

    const data = formContext.getValues()
    handlePreview(data)
  }

  return (
    <Toolbar>
      <div className='cardCrudBottomButtons'>
        <div className='leftSide'>
          {btnCancel && (
            <Button
              size='medium'
              variant='outlined'
              color='error'
              onClick={handleCancel}
              disabled={loading}
            >
              {translate('ra.action.cancel')}
            </Button>
          )}
          {btnPreview && handlePreview && (
            <LoadingButton
              size='medium'
              variant='outlined'
              onClick={onPreviewClick}
              disabled={loading}
              loading={loadingPreview}
            >
              {translate('ra.action.preview')}
            </LoadingButton>
          )}
          {btnEdit && permissions?.hasEdit && (
            <EditButton
              className='button'
              size='medium'
              label={translate('ra.action.edit')}
              icon={<Edit />}
              variant='contained'
              disabled={loading}
            />
          )}
          {btnSave && permissions?.hasCreate && (
            <SaveButton
              size='medium'
              icon={<Save />}
              variant='contained'
              onClick={handleClick}
              alwaysEnable={!loading}
              disabled={loading}
            />
          )}
          {btnCancel && (
            <Button
              size='medium'
              variant='outlined'
              color='error'
              onClick={handleCancel}
              disabled={loading}
              sx={{ marginLeft: '15px' }}
            >
              {translate('ra.action.cancel')}
            </Button>
          )}
        </div>
        <div className='rightSide'>
          {btnDelete && permissions?.options?.delete && (
            <DeleteButtonWithConfirmation
              record={record}
              resource={resource}
              name={getResourceName(record, fieldsName)}
              genderElement={genderElement}
              label={translate('ra.action.delete')}
              variant='outlined'
              color='error'
              size='medium'
            />
          )}
        </div>
      </div>
    </Toolbar>
  )
}
